"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const registerParameters_1 = require("./tasks/registerParameters");
function bootstrap() {
    return Promise.all([
        registerParameters_1.registerParameters(),
    ]);
}
exports.bootstrap = bootstrap;



// WEBPACK FOOTER //
// ./gatsby-builder/bootstrap/browser.ts